module.exports = __webpack_public_path__ + "img/Pinterest_logo.d25a114b.png";